import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/close.svg';
import actions from '../../../actions';
import * as Constant from '../../../constants/actionTypes';
import { labelName, onAddInertToDrawer } from '../../UtilsWeb';
import styles from './styles';

class LanguageScreen extends PureComponent {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    changeLocale: PropTypes.func.isRequired,
    supportedLanguages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      locale: props.locale,
    };
  }

  onSelect = () => {
    const { changeLocale, toggle } = this.props;
    const { locale } = this.state;
    sessionStorage.setItem('locale', locale);
    changeLocale(locale);
    onAddInertToDrawer('provider-card-template', 'remove');
    toggle();
  };

  handleClose = () => {
    const { toggle } = this.props;
    onAddInertToDrawer('provider-card-template', 'remove');
    toggle();
  };

  selectLanguage = event => {
    this.setState({ locale: event.target.value });
  };

  render() {
    const { classes, open: isOpen, supportedLanguages } = this.props;
    const { locale } = this.state;
    return (
      <div>
        <Dialog
          open={isOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title" className={classes.dialog}>
            <div className={classes.mainDiv}>
              <p className={classes.pTag}>{labelName(Constant.LABEL_LANGUAGE)}</p>
              <IconButton aria-label="Close" onClick={this.handleClose} className={classes.iconBtn}>
                <DeleteIcon className={classes.SvgIcon} />
              </IconButton>
            </div>
          </DialogTitle>
          <div className={classes.dialogContent}>
            <RadioGroup
              aria-label="Language"
              name="Language1"
              value={locale}
              onChange={this.selectLanguage}
            >
              {supportedLanguages?.data?.map(item => (
                <FormControlLabel
                  key={item.LanguageCode.toLowerCase()}
                  value={item.LanguageCode.toLowerCase()}
                  control={
                    <Radio color="primary" inputProps={{ className: classes.formInputControl }} />
                  }
                  label={item.Language}
                  color="primary"
                  className={classes.formControlLabel}
                  aria-label={item.Language}
                  sx={{ margin: 0 }}
                />
              ))}
            </RadioGroup>
          </div>
          <DialogActions className={classes.dialogActions}>
            <Button variant="contained" color="primary" onClick={this.onSelect} autoFocus fullWidth>
              {labelName(Constant.LABEL_LANGUAGE_SUBMIT)}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

LanguageScreen.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const { locale } = state.locale;
  const { supportedLanguages } = state;
  return {
    locale,
    supportedLanguages,
  };
};

const mapDispatchToProps = dispatch => ({
  changeLocale: locale => {
    dispatch(actions.changeLocale(locale));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LanguageScreen));
